(function () {
    'use strict';

    var module = angular.module('uwAgenda.charts');
    module.directive('messageTypeFilter', ['$filter', 'ChartFilterBroadcast', MessageTypeFilterFn]);

    // filter directive for multiple message type filter selection
    function MessageTypeFilterFn($filter, ChartFilterBroadcast) {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/charts/templates/message-type-filter.template.html',
            scope: {
                messageTypes: '=',
                paginationService: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // broadcast listener
            var listener = null;

            // number of set filter
            scope.numFilters = 0;

            //activate directive
            activate();

            // filter list
            scope.filter = function (type) {
                //reset
                scope.numFilters = 0;

                // type change
                if (type !== null) {
                    type.vmSelected = !type.vmSelected;
                }

                // refresh view
                refresh();
            };

            // on destroy
            scope.$on('$destroy', function () {
                // unregister from broadcast
                if (listener) {
                    listener();
                    listener = null;
                }
            });

            // refresh view
            function refresh() {
                // number of selected states
                scope.numFilters = 0;
                for (var i = 0; i < scope.messageTypes.length; i++) {
                    if (scope.messageTypes[i].vmSelected) {
                        scope.numFilters++;
                    } //if
                }//for
            } // refresh

            // listen
            function listen() {
                //check for doing a refresh
                listener = scope.$on(ChartFilterBroadcast.MessageTypeRefresh, function () {
                    refresh();
                });
            } // listen

            // init work
            function activate() {
                // refresh view
                refresh();

                // listen
                listen();
            } //activate
        } // link
    }
})();